// extracted by mini-css-extract-plugin
module.exports = {"item":"hit_commentaries_list-module__item--6_Wxu"};